"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerContent = DrawerContent;
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const react_router_dom_1 = require("react-router-dom");
const index_1 = require("../../index");
const Drawer_1 = require("./Drawer");
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const useStyles = (0, styles_1.makeStyles)({
    container: {
        marginTop: '2rem',
    },
    listItemRoot: {
        marginTop: '8px',
        height: '40px',
        borderLeft: `4px solid transparent`,
        '&.Mui-selected': {
            backgroundColor: index_1.StyleVariables.colors.surface.selected,
            borderLeft: `4px solid ${index_1.StyleVariables.colors.interactive.default}`,
            color: index_1.StyleVariables.colors.interactive.default,
            '&:hover': {
                backgroundColor: index_1.StyleVariables.colors.surface.selected,
            },
        },
    },
    selected: {
        backgroundColor: index_1.StyleVariables.colors.surface.selected,
    },
    listItemIconRoot: {
        minWidth: 'unset',
    },
    listItemIconRootOpen: {
        minWidth: '40px',
    },
    listItemIconSelected: {
        color: index_1.StyleVariables.colors.interactive.default,
    },
    drawerItemImageIcon: {
        width: '24px',
        height: '24px',
    },
    drawerItemText: {
        '& span': {
            fontFamily: index_1.StyleVariables.fonts.family.body,
            fontSize: index_1.StyleVariables.fonts.size.h6,
            fontWeight: index_1.StyleVariables.fonts.weight.medium,
        },
    },
    divider: {
        marginTop: '8px',
    },
});
function DrawerListItem({ drawerItem: item }) {
    const classes = useStyles();
    const history = (0, react_router_dom_1.useHistory)();
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const drawerContext = (0, react_1.useContext)(Drawer_1.Drawer.Context);
    const isDrawerOpen = drawerContext.isOpen;
    const isSelected = item.href
        ? !!(0, react_router_dom_1.matchPath)(pathname, { path: item.href, exact: true })
        : false;
    const handleClick = (e, item) => {
        item.href && history.push(item.href);
        item.onClick && item.onClick(e, item);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        item.showDivider && react_1.default.createElement(core_1.Divider, { className: classes.divider }),
        react_1.default.createElement(ListItem_1.default, { button: true, key: item.title, classes: {
                root: classes.listItemRoot,
                selected: classes.selected,
            }, selected: isSelected, onClick: (e) => handleClick(e, item), "data-testid": item.dataTestId, "aria-label": item.title },
            react_1.default.createElement(core_1.Tooltip, { title: item.title },
                react_1.default.createElement(ListItemIcon_1.default, { classes: {
                        root: (0, clsx_1.default)([
                            classes.listItemIconRoot,
                            {
                                [classes.listItemIconSelected]: isSelected,
                                [classes.listItemIconRootOpen]: isDrawerOpen,
                            },
                        ]),
                    } }, item.icon)),
            isDrawerOpen && (react_1.default.createElement(ListItemText_1.default, { primary: item.title, className: classes.drawerItemText })))));
}
function DrawerContent({ drawerItems }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.container }, drawerItems.map((item, index) => (react_1.default.createElement(DrawerListItem, { key: index, drawerItem: item })))));
}
